export type LngLatPoint = readonly [number, number];

export function coordinatesAlmostEqual(a: LngLatPoint, b: LngLatPoint, tolerance = 1e-6): boolean {
  return Math.abs(a[0] - b[0]) <= tolerance && Math.abs(a[1] - b[1]) <= tolerance;
}

export function closedLineToPolygonRing(coordinates: unknown, tolerance = 1e-6): [number, number][] | null {
  if (!Array.isArray(coordinates) || coordinates.length < 4) return null;
  const points = coordinates.filter((point): point is [number, number] =>
    Array.isArray(point) && typeof point[0] === "number" && typeof point[1] === "number"
  );
  if (points.length < 4) return null;

  const first = points[0];
  const last = points[points.length - 1];
  if (!coordinatesAlmostEqual(first, last, tolerance)) return null;

  const ring = points.map((point) => [point[0], point[1]] as [number, number]);
  ring[ring.length - 1] = [first[0], first[1]];
  return ring;
}
